import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import useFetchBonds, { SearchBondsPayload } from '../../../../hooks/documents/useFetchBonds';
import { CompanyPageParams } from '../../../../models/CompanyPageParams';
import { BondsSortOption } from '../../../../services/securities/securities.constants';
import { BONDS_TABLE_CONFIG, getDefaultFetchBondsPayload } from '../CompanyDocumentsTab.logic';
import DocumentsTable from '../DocumentsTable';

const CompanyBondsTable = (): React.ReactElement => {
  const { issuerId } = useParams() as CompanyPageParams;
  const [fetchBondsPayload, setFetchBondsPayload] = useState<SearchBondsPayload>(getDefaultFetchBondsPayload(issuerId));
  const { data, isLoading } = useFetchBonds(issuerId, fetchBondsPayload);

  const onSort = (dataKey: string) => {
    setFetchBondsPayload((prevPayload) => {
      const sortBy = BondsSortOption[dataKey];
      if (prevPayload.sort === sortBy) {
        return { ...prevPayload, sortDesc: !prevPayload.sortDesc };
      }

      return { ...prevPayload, sortDesc: true, sort: sortBy };
    });
  };

  return (
    <DocumentsTable
      config={BONDS_TABLE_CONFIG}
      data={data}
      isLoading={isLoading}
      onSort={onSort}
      sortBy={fetchBondsPayload.sort!}
      sortDesc={fetchBondsPayload.sortDesc!}
      dataTestId="bonds-table"
    />
  );
};

export default CompanyBondsTable;
